import { Modal, Button } from "react-bootstrap";
import { X } from "react-bootstrap-icons";

export interface ModalConfirmEnvioExtratoProps {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
  enviando: boolean;
}

const ModalConfirmEnvioExtrato = ({
  show,
  onClose,
  onConfirm,
  enviando,
}: ModalConfirmEnvioExtratoProps) => (
  <Modal
    show={show}
    onHide={onClose}
    centered
    size="lg"
    contentClassName="modal-confirm-extract-custom"
  >
    <Modal.Header>
      <Modal.Title style={{ color: "#005ca9" }}>CONFIRMAR ENVIO</Modal.Title>
      <Button
        variant="link"
        onClick={onClose}
        style={{
          color: "#005ca9",
          fontSize: 32,
          marginRight: -10,
          marginTop: -10,
        }}
        className="p-0 ms-auto"
        aria-label="Fechar"
      >
        <X />
      </Button>
    </Modal.Header>

    <Modal.Body className="text-center">
      Deseja realmente enviar o extrato para o sindicato?
    </Modal.Body>

    <Modal.Footer className="justify-content-center gap-3">
      <Button
        onClick={onClose}
        style={{
          minWidth: "140px",
          background: "white",
          border: "1px solid #005ca9",
          color: "#005ca9",
        }}
      >
        NÃO
      </Button>
      <Button
        onClick={onConfirm}
        disabled={enviando}
        style={{
          minWidth: "140px",
          background: "#005ca9",
          border: "1px solid #005ca9",
          color: "white",
        }}
      >
        {enviando ? (
          <>
            <span
              className="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>
            Enviando...
          </>
        ) : (
          "SIM"
        )}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default ModalConfirmEnvioExtrato;
